export default __webpack_public_path__ + "static/media/prevArrow.c2317a98.svg";